import http from '../helpers/http-common';
import { IPastaCleanDTO, IPastaDTO, IPastaFullDTO } from '../models/happy-code-api.model';
import { IAxiosResponseCustom } from '../models/http.model';
import { baseCreate } from './base/base-create.service';
import { baseFindById } from './base/base-find-id.service';
import { baseFindList } from './base/base-find-list.service';
import { baseFind } from './base/base-find.service';
import { baseUpdate } from './base/base-update.service';

export const usePastaService = () => {
	const resourceURL = '/aca-pasta';



	return {
		...baseFind<IPastaCleanDTO, IPastaDTO, IPastaFullDTO>(resourceURL),
		...baseFindList<IPastaCleanDTO, IPastaDTO, IPastaFullDTO>(resourceURL),
		...baseFindById<IPastaCleanDTO, IPastaDTO, IPastaFullDTO>(resourceURL),
		...baseCreate<IPastaCleanDTO, IPastaDTO, IPastaFullDTO>(resourceURL),
		...baseUpdate<IPastaCleanDTO, IPastaDTO, IPastaFullDTO>(resourceURL),
		patch: (toUpdate: any): Promise<IAxiosResponseCustom<IPastaCleanDTO>> => http.patch(`${resourceURL}/${toUpdate.id}`, toUpdate),
		patchFull: (toUpdate: any): Promise<IAxiosResponseCustom<IPastaCleanDTO>> => http.patch(`${resourceURL}/full/${toUpdate.id}`, toUpdate),
	};
};
